import { memo, useCallback } from "react";
import { ClassmateInfo, SociometryQuestion as SociometryQuestionType } from "shared/types/sociometry";
import { classNames } from "shared/lib/classNames/classNames";
import cls from "./SociometryQuestion.module.scss";
import { SociometrySelect } from "../SociometrySelect/SociometrySelect";

interface SociometryQuestionProps {
    question: SociometryQuestionType;
    classmates: ClassmateInfo[];
    selectedClassmates: string[];
    onSelectionChange: (chosen: string[]) => void;
    className?: string;
}

const REQUIRED_SELECTIONS = 3;

export const SociometryQuestion = memo((props: SociometryQuestionProps) => {
    const { question, classmates, selectedClassmates, onSelectionChange, className } = props;

    const handleSelect = useCallback(
        (index: number) => (id: string) => {
            const newSelections = [...selectedClassmates];

            if (id === "") {
                newSelections[index] = "";
            } else {
                newSelections[index] = id;
            }

            onSelectionChange(newSelections);
        },
        [selectedClassmates, onSelectionChange],
    );

    const getDisabledIds = (currentIndex: number): string[] => {
        return selectedClassmates.filter((id, idx) => id && idx !== currentIndex);
    };

    return (
        <div className={classNames(cls.sociometryQuestion, {}, [className])}>
            <div className={cls.questionText}>{question.text}</div>

            <div className={cls.selectorsWrapper}>
                {Array.from({ length: REQUIRED_SELECTIONS }).map((_, index) => (
                    <SociometrySelect
                        key={index}
                        classmates={classmates}
                        selectedIds={selectedClassmates[index] ? [selectedClassmates[index]] : []}
                        disabledIds={getDisabledIds(index)}
                        onSelect={handleSelect(index)}
                        placeholder="Выберите одноклассника"
                    />
                ))}
            </div>
        </div>
    );
});

SociometryQuestion.displayName = "SociometryQuestion";
